<template>
  <b-modal 
    body-class="p-0 m-0"
    dialog-class="w-60"
    v-model="modalShow"
    no-close-on-backdrop
    :hide-header-close="hideModal"
    @close="closeModal"
    size="lg"
    id="modal-select-change-pass"
    :title="'Change Password'"
    :hide-footer="true"
  >
    <AccountSettingPassword :accountNew="accountNew" />
  </b-modal>
</template>

<script>
import AccountSettingPassword from "@/views/auth/account-setting/AccountSettingPassword.vue";
export default {
  components: {
    AccountSettingPassword,
  },
  props: {
    value: { type: Boolean },
    hideModal: { type: Boolean,default: false},
    accountNew: { type: Boolean, default: false },
  },
  mounted: function () {
  },
  computed: {
    modalShow: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeModal: function () {
      this.modalShow = false;
      this.$store.commit("appConfig/CHANGE_PASS", false);
    },
  },
};
</script>

<style>
.w-60 {
  width: 60% !important;
}
</style>
